import {Col, Row} from 'antd';
import {t} from 'i18next';
import React from 'react';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import HeaderPages from '../../../../component/page-components/pages-header';
import useAddDataGroup from './add-data-group.hooks';
import TabDetailDataGroup from './tab-detail-data-group';
import TabSetDataGroup from './tab-set-data-group';
import SuccessModal from "../../../../component/modal/SuccessModal";
import {ROUTES} from '../../../../constant/routeConstant';
import style from '../DataGroup.module.css'
import ModalSuccessUpdated from "../../../../component/modal/ModalSuccessUpdated";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import ModalConfirmLeave from '../../../../component/modal/ModalConfirmLeave';

const AddDataGroup = () => {

    const {
        tab,
        handleNext,
        handleBack,
        backToList,
        dataGroupName,
        setDataGroupName,
        description,
        setDescription,
        depotList,
        setDepotList,
        flag,
        setFlag,
        dataGroupNameError,
        setDataGroupNameError,
        descriptionError,
        setDescriptionError,
        depotListError,
        setDepotListError,
        onChange,
        handleSave,
        successModalOpen,
        navigate,
        _onOk,
        failedMessages,
        failedModalOpen,
        change,
        setFailedModalOpen,
        showConfirm,
        setShowConfirm
    } = useAddDataGroup();

    return (
        <>
            <div className='p-5 h-fit'>

                {/* <ModalConfirmLeave
          visible={showConfirm}
          action={() => setShowConfirm(false)}
          route={ROUTES.SKILLSET.LIST}
        /> */}
<ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={() => navigate(ROUTES.DATA_GROUP.LIST)}
      />
                <SuccessModal
                    isOpen={successModalOpen}
                    onOk={() => navigate(ROUTES.DATA_GROUP.LIST)}
                    closable={false}
                    width={280}
                    className={style.successModal}
                    okText="Ok"
                    title="Success"
                    description={`Success Add Data Group`}
                />

                <Breadcumbs
                    jmlLevel={4}
                    menuLevel1={`Admin`}
                    menuLevel2={`User Management`}
                    menuLevel3={`Data Group`}
                    menuLevel4={`Add Data Group`}
                />
                <HeaderPages title="Add Data Group" menuType="add" handleBack={change
                ? () => setShowConfirm(true)
                : backToList}/>

                <div className=' bg-white-100 p-5 rounded-[10px] h-96'>
                    <div className='w-1/2 mt-5'>
                        <Row className='bg-[#F3F3F3] h-[52px] rounded-md'>
                            <Col span={12}>
                                <Row>
                                    <Col className='grid place-items-center h-[52px]' span={4}>
                                        <div
                                            className={`border ${tab === 1 ? 'border-red-100 bg-red-100' : 'border-[#228B22] bg-[#228B22]'} rounded-full w-[36px] h-[36px] grid place-items-center`}>
                                            <p className='font-sans text-xl font-semibold text-white-100'>1</p>
                                        </div>
                                    </Col>
                                    <Col className='flex items-center' span={12}>
                                        <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-red-100' : 'text-[#228B22]'}`}> Detail
                                            Data Group </p>
                                    </Col>
                                    <Col className='flex items-center' span={8}>
                                        <hr className={`border-2 w-full ${tab === 1 ? ' border-[#D7D7D7] border-dashed ' : 'border-[#228B22] border-solid'} `}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col className='grid place-items-center h-[52px]' span={4}>
                                        <div
                                            className={`border rounded-full w-[36px] h-[36px] grid place-items-center ${tab === 1 ? 'bg-[#FFFFFF] border-[#FFFFFF]' : 'border-red-100 bg-red-100'}`}>
                                            <p className={`font-sans text-xl font-semibold ${tab === 1 ? 'text-[#ACACAC]' : 'text-white-100'}`}>2</p>
                                        </div>
                                    </Col>
                                    <Col className='flex items-center' span={20}>
                                        <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-[#ACACAC]' : 'text-red-100'}`}> Set
                                            Data Scope </p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    {
                        tab === 1 ? (
                            <TabDetailDataGroup onChange={onChange} description={description} dataGroupName={dataGroupName} dataGropNameError={dataGroupNameError}
                                                descriptionError={descriptionError}/>
                        ) : (
                            <TabSetDataGroup setSelectedDepot={setDepotList} setFlag={setFlag}
                                             depotListError={depotListError}/>
                        )
                    }

                </div>
            </div>
            <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
                {
                    tab === 1 ? (
                        <>
                            <PrimaryButton action={handleNext} text={t("COMMON:NEXT")}/>
                            <SecondaryButton action={change
                ? () => setShowConfirm(true)
                : backToList} text={t("USER_DETAIL:CANCEL")}/>
                        </>
                    ) : (
                        <>
                            <PrimaryButton action={handleSave} text={t("USER_DETAIL:SAVE")}/>
                            <SecondaryButton action={handleBack} text={"Previous"}/>
                        </>
                    )
                }
            </div>

            <ModalSuccessUpdated
                isVisible={successModalOpen}
                onOk={_onOk}
            />

            <NotifFailedSaved
                visible={failedModalOpen}
                message={failedMessages}
                action={() => { setFailedModalOpen(false) }}
            />

        </>
    );
}

export default AddDataGroup;